var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('vue-title', {
    attrs: {
      "title": "Faqs - MyWhoosh! Your Indoor Cycling Solution"
    }
  }), _vm._m(0), _c('section', {
    staticClass: "description"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, _vm._l(_vm.faqs, function (faq, i) {
    return _c('section', {
      key: i,
      staticClass: "col-md-12"
    }, [_c('h3', [_vm._v(_vm._s(faq.topic))]), _c('p', [_vm._v(_vm._s(faq.topic_description))]), _c('div', {
      staticClass: "accordion accordion-faq",
      attrs: {
        "id": ("accordion-" + i)
      }
    }, _vm._l(faq.questions, function (question, j) {
      return _c('div', {
        key: j,
        staticClass: "card"
      }, [_c('div', {
        staticClass: "card-header",
        attrs: {
          "id": ("heading-" + i + "-" + j)
        }
      }, [_c('h2', {
        staticClass: "mb-0"
      }, [_c('button', {
        staticClass: "btn btn-link btn-block text-left collapsed ",
        attrs: {
          "type": "button",
          "data-toggle": "collapse",
          "data-target": ("#collapse-" + i + "-" + j),
          "aria-expanded": "false",
          "aria-controls": ("collapse-" + i + "-" + j)
        }
      }, [_c('span', [_vm._v("Q " + _vm._s(j + 1) + ": " + _vm._s(question.question))]), _c('i', {
        staticClass: "fas fa-caret-down"
      })])])]), _c('div', {
        staticClass: "collapse",
        attrs: {
          "id": ("collapse-" + i + "-" + j),
          "aria-labelledby": ("heading-" + i + "-" + j),
          "data-parent": ("#accordion-" + i)
        }
      }, [_c('div', {
        staticClass: "card-body",
        domProps: {
          "innerHTML": _vm._s(question.answer)
        }
      })])]);
    }), 0)]);
  }), 0)])])], 1);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('section', {
    staticClass: "banner bg-m faqs-banner"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "overlay"
  }), _c('div', {
    staticClass: "sreachBar"
  }, [_c('h1', {
    staticStyle: {
      "text-transform": "none"
    }
  }, [_vm._v(" FAQs ")])])])]);
}]

export { render, staticRenderFns }